(() => {
  const scope = '[data-fm-buggy-product]';
  const prepare = () => document.querySelectorAll(`${scope} form[data-type="add-to-cart-form"]`).forEach(form => form.removeAttribute('novalidate'));
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[data-type="add-to-cart-form"]')) return;
    const root = form.closest(scope);
    if (!root) return;
    const select = root.querySelector('[data-fm-buggy-year]');
    const input = form.querySelector('input[name="id"]');
    let variant = null;
    try { variant = JSON.parse(root.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch { variant = null; }
    const option = select?.selectedOptions[0];
    const valid = Boolean(select?.value && option && !option.disabled && variant?.available
      && String(variant.id) === input?.value && variant.options?.[0] === select.value);
    if (valid) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    select?.focus();
    select?.reportValidity();
  }, true);
  document.addEventListener('product-info:loaded', prepare);
  document.addEventListener('shopify:section:load', prepare);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  else prepare();
})();
